// extracted by mini-css-extract-plugin
export default {"setting-card":"SettingsCard_setting-card__t2f-i"};